import { Controller } from '@hotwired/stimulus';

const FEEDBACK_TIMEOUT_MS = 1500;

export default class extends Controller {
  static targets = ['idleIcon', 'copiedIcon'];
  static values = { text: String };

  disconnect() {
    clearTimeout(this.feedbackTimeout);
  }

  async copy() {
    try {
      await navigator.clipboard.writeText(this.textValue);
    } catch {
      return;
    }

    this.toggleIcons(true);
    clearTimeout(this.feedbackTimeout);
    this.feedbackTimeout = setTimeout(() => this.toggleIcons(false), FEEDBACK_TIMEOUT_MS);
  }

  toggleIcons(copied) {
    if (this.hasIdleIconTarget) this.idleIconTarget.classList.toggle('hidden', copied);
    if (this.hasCopiedIconTarget) this.copiedIconTarget.classList.toggle('hidden', !copied);
  }
}
